import type { CategoriesV2 } from "storefront/Categories";
import type { SizesByCategory } from "storefront/Size";
import {
  get as getFromCache,
  put as putToCache,
} from "storefront/lib/memoryCache";
import { get } from "storefront/GrailedAPI/request";

export const CACHE_KEY = "get_listing_categories_from_config";

export type ResponseData = {
  categories: CategoriesV2;
  sizes: SizesByCategory;
};

type Response = {
  data: ResponseData;
};

const unpack = ({ data }: Response): ResponseData => data;

let inFlightPromise: Promise<ResponseData> | null = null;

const getCategories = (): Promise<ResponseData> => {
  const cachedValue = getFromCache(CACHE_KEY);
  if (cachedValue) return Promise.resolve(cachedValue);
  if (inFlightPromise) return inFlightPromise;

  inFlightPromise = get<Response>("/api/config/categories")
    .then(unpack)
    .then((data) => {
      putToCache(CACHE_KEY, data);
      return data;
    })
    .finally(() => {
      inFlightPromise = null;
    });

  return inFlightPromise;
};

export default getCategories;
